module.exports = __webpack_public_path__ + "static/logo-sheyla-rojo-685fc24247939011ddb591505ed1b98d.png";